import { PropsWithChildren } from "react";

const DialogFooter = ({ children }: PropsWithChildren) => {
  return (
    <div data-scope="dialog" data-part="footer">
      {children}
    </div>
  );
};

export default DialogFooter;
